export default "__VITE_ASSET__pGo$z60S__"